import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { MyRunsSearchMode } from '@neptune/home-page-domain';
import { createCurrentRouteParamSelector } from '@neptune/shared/routing-business-logic';

import { updateRouteParams } from './update-route-params';

const myRunsSearchModeModeSelector = createCurrentRouteParamSelector('myRunsSearchMode');

export const useMyRunsSearchMode = () => {
  const myRunsSearchMode: MyRunsSearchMode =
    useSelector(myRunsSearchModeModeSelector) ?? MyRunsSearchMode.MY;
  const dispatch = useDispatch();

  const changeMyRunsSearchMode = React.useCallback(
    (value: MyRunsSearchMode) => {
      dispatch(updateRouteParams({ myRunsSearchMode: value }));
    },
    [dispatch],
  );

  return {
    myRunsSearchMode,
    changeMyRunsSearchMode,
  };
};
